import { render, staticRenderFns } from "./configuration-automation-portions-grid.vue?vue&type=template&id=0192e85a&scoped=true&"
import script from "./configuration-automation-portions-grid.ts?vue&type=script&lang=ts&"
export * from "./configuration-automation-portions-grid.ts?vue&type=script&lang=ts&"
import style0 from "./configuration-automation-portions-grid.scss?vue&type=style&index=0&id=0192e85a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0192e85a",
  null
  
)

export default component.exports